import { render, staticRenderFns } from "./bdcmap.vue?vue&type=template&id=db0ea3d0&scoped=true"
import script from "./bdcmap.vue?vue&type=script&lang=js"
export * from "./bdcmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0ea3d0",
  null
  
)

export default component.exports